module.exports = "mutation ($id: ID!) {\n  ContactDelete(id: $id) {\n    id\n  }\n}\n"